import { Card } from '../../models/card';
import { ScheduleWindow } from '../../models/schedule-window';
import { AppState } from '../index';
import { PickupBookingTypeEnum } from '../../enum/pickup-booking-type.enum';
import { Availability } from '../../models/availability';
import { createSelector } from '@ngrx/store';
import { ServerMessage } from '../../models/server-message';
import { Parameter } from 'src/app/models/parameter';

export interface PickupState {
    pickupBookingType: PickupBookingTypeEnum;
    courierModule?: string;
    courierCode?: string;
    shipmentSelection: string[];
    address: Card;
    date?: string;
    readyTime?: string;
    closeTime?: string;
    windows: ScheduleWindow[];
    minimumWindowMinutes: number;
    pickupReference?: string;
    busy: boolean;
    availability: Availability[];
    success?: boolean;
    messages: ServerMessage[];
    pickupParameters: Parameter[];
    pickupSelection: string[];
}

export const selectPickupState = (state: AppState) => state.pickup;

export const selectPickupCourierModule = createSelector(selectPickupState,
    (state: PickupState) => state.courierModule);

export const selectPickupAvailability = createSelector(selectPickupState,
    (state: PickupState) => state.availability);

export const selectPickupShipmentSelection = createSelector(selectPickupState,
    (state: PickupState) => state.shipmentSelection);

export const selectPickupBusy = createSelector(selectPickupState,
    (state: PickupState) => state.busy);

export const selectPickupDate = createSelector(selectPickupState,
    (state: PickupState) => state.date);

export const selectPickupReadyTime = createSelector(selectPickupState,
    (state: PickupState) => state.readyTime);

export const selectPickupCloseTime = createSelector(selectPickupState,
    (state: PickupState) => state.closeTime);

export const selectPickupBookingData = createSelector(selectPickupState,
    (state: PickupState) => ({
        selection: state.shipmentSelection,
        date: state.date,
        readyTime: state.readyTime,
        closeTime: state.closeTime,
        parameters: state.pickupParameters
    }));

export const selectPickupSelection = createSelector(selectPickupState,
    (state: PickupState) => state.pickupSelection);

export const selectPickupMessages = createSelector(selectPickupState,
    (state: PickupState) => state.messages);

export const selectPickupSuccess = createSelector(selectPickupState,
    (state: PickupState) => state.success);
